import React from "react";
import { useNavigate } from "react-router-dom";
import { ThemeInsightItemProps } from "../../../interfaces/themes";

const ThemeInsightItem: React.FC<ThemeInsightItemProps> = ({
  insight,
  themeKey,
  navigationContext,
}) => {
  const navigate = useNavigate();

  const summary = insight.summary?.replace(/^Rationale:\s*/i, "");

  const handleInteractionClick = () => {
    const interactionId = insight.id;
    if (!interactionId) return;

    const navCtx = navigationContext || {};

    const stateToPass = {
      activeView: navCtx.activeView,
      themesActiveKey: themeKey,
      customDateRange: navCtx.customDateRange,
      startEndMeetingTime: navCtx.startEndMeetingTime,
      isSlideOverOpen: navCtx.isSlideOverOpen,
      clientName: navCtx.clientName,
      orgId: navCtx.orgId,
      subOrgId: navCtx.subOrgId,
      accountViewState: navCtx.accountViewState,
      parent_page_identifier: navCtx.parentPageIdentifier,
      slideOverParent: navCtx.slideOverParent,
    };

    navigate(`/meeting/${interactionId}`, {
      state: stateToPass,
    });
  };


  return (
    <div
      className="theme-insight-item"
      data-sentiment={insight.sentiment || undefined}
      data-theme={themeKey}
    >
      <span className="theme-insight-item__dot" />
      <div className="theme-insight-item__content">
        <div className="theme-insight-item__row">
          <span className="theme-insight-item__date">{insight.date}</span>
          <button
            type="button"
            className="theme-insight-item__interaction"
            onClick={handleInteractionClick}
          >
            {insight.interactionName}
          </button>
          <span className="theme-insight-item__duration">
            {insight.callout}
          </span>
          {insight.sentiment && (
            <span className="theme-insight-item__pill">{insight.sentiment}</span>
          )}
        </div>
        <div className="theme-insight-item__summary">
          <strong>Rationale:</strong> <span>{summary}</span>
        </div>
      </div>
    </div>
  );
};

export default ThemeInsightItem;
